import * as React from "react"
import parse from "html-react-parser"

import "./people_also_ask.scss"

function PeopleAlsoAsk({sectionContent}) {
    return (
      <div className="resource-people-also-ask">
        <h2 className="qAndA-title">People also ask...</h2>
        {!!sectionContent && (
          <section itemProp="articleBody" className="peopleAsk">
            {parse(sectionContent)}
          </section>
        )}
      </div>
    )
  }
  export default PeopleAlsoAsk
  